import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import Magnetic from "./animations/Magnetic";

export default function IndustryPulse() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  return (
    <section ref={ref} className="relative py-12 md:py-16 overflow-hidden flex items-center justify-center">
      {/* BACKGROUND */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/bg.webp')",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      />

      {/* BLUE OVERLAY */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(135deg, rgba(0,51,77,0.92) 0%, rgba(0,102,153,0.85) 100%)",
        }}
      />

      {/* CONTENT */}
      <div className="relative z-10 w-full max-w-[1800px] mx-auto px-4 sm:px-8 flex flex-col items-center">

        {/* TITLE — always one line */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
          className="w-full text-center"
        >
          <h2 className="text-white text-3xl sm:text-5xl md:text-[5vw] lg:text-[4.5vw] leading-tight tracking-tight font-extralight whitespace-nowrap">
            #Great_Stories_{" "}
            <span className="font-serif italic font-medium text-[#7dd3fc]">Begin</span>
            {" "}_Here
          </h2>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-8 flex flex-col items-center w-full"
        >
          <Magnetic strength={0.35}>
            <div className="relative group inline-block">
              <div className="absolute -top-2 -left-2 w-4 h-4 border-t-2 border-l-2 border-white opacity-0 group-hover:opacity-100 group-hover:-top-3 group-hover:-left-3 transition-all duration-300 z-20" />
              <div className="absolute -bottom-2 -right-2 w-4 h-4 border-b-2 border-r-2 border-white opacity-0 group-hover:opacity-100 group-hover:-bottom-3 group-hover:-right-3 transition-all duration-300 z-20" />
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeRWhgPFDJmmzVOxGZht9ZVU5tBV8ADS6XTkWXdNFCnTHBihw/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="relative flex items-center justify-center gap-2 md:gap-4 px-6 py-2.5 md:px-14 md:py-5 bg-white text-[#006699] hover:bg-[#bae6fd] transition-colors duration-500 rounded-none shadow-2xl z-10"
              >
                <span className="text-[9px] md:text-xs tracking-[0.2em] font-bold uppercase">
                  JOIN IEEE ISIMS SB
                </span>
                <ArrowRight size={14} className="md:size-[18px] group-hover:translate-x-2 transition-transform duration-300" />
              </a>
            </div>
          </Magnetic>
        </motion.div>

      </div>
    </section>
  );
}